export function Brand({ compact = false }: { compact?: boolean }) {
  return <a className="brand" href="https://trykate.app" aria-label="Kate">
    <picture className="brand-mark"><source type="image/webp" srcSet="/branding/kate-logo.webp"/><img src="/branding/kate-logo.png" width={40} height={40} alt="" decoding="async"/></picture>
    {!compact && <span>Kate<b aria-hidden="true">.</b></span>}
  </a>;
}
